<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="$t('popup.register.caption.chooseitem')"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="md" v-html="content.html"></div>
                    <div class="md">
                        <div class="cp input select" :class="[errors.has('classStr')? 'is-error': '']" :data-error="errors.first('classStr')">
                            <select v-model="classStr" v-validate="'required'" name="classStr">
                                <option value="">{{ $t('popup.register.choosecategory') }}</option>
                                <option
                                    v-for="item in classList"
                                    :key="item" :value="item">{{ item }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="md">
                        <div class="cp input select" :class="[errors.has('typeStr')? 'is-error': '']" :data-error="errors.first('typeStr')">
                            <select v-model="typeStr" v-validate="'required'" name="typeStr">
                                <option value="">{{ $t('popup.register.chooseproduct') }}</option>v
                                <option
                                    v-for="item in typeList"
                                    :key="item" :value="item">{{ item }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){

            return {
                classStr: '',
                typeStr: '',
                option: {},
            }
        },
        computed: {
            classList: function(){
                let $option = this.option,
                    $result = []

                for( let _key in $option ) {
                    $result.push(_key);
                }

                return $result;
            },
            typeList: function(){
                let $option = this.option,
                    _classStr = this.classStr,
                    $result = []

                let $content = this.content,
                    $value = $content.value;

                if( _classStr && $option[_classStr] ) {
                    let $options = $option[_classStr]

                    $options.forEach(item => {

                        if( !$value.includes(_classStr +'-'+ item) ) {
                            $result.push(item);
                        }
                    });
                }
                
                return $result;
            },
            btns: function(){

                return [
                    {
                        text:this.$t('site.status.confirm'),
                        themes: 'major',
                        func: 'action',
                    }
                ]
            },
        },
        methods: {
            action: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        let $content = this.content,
                            $_action = $content.action;

                        let _classStr = this.classStr,
                            _typeStr = this.typeStr;

                        $_action(_classStr +'-'+ _typeStr);

                        if( $content.actionStopClose !== true ) {
                            this.close();
                        }
                    }
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
            setData: function(){
                let $content = this.content,
                    $options = $content.options; //可以是 Object 也可以是 Array

                this.$set(this, 'option', $options);
            }
        },
        created: function(){
            this.setData();
        }
    }
</script>

<style scoped lang="scss">

    .pop-up-content {

        .md {

            + .md {
                margin-top: 6px;
            }
        }
    }

    .input {
        width: 100%;
    }
</style>
